import React, { ReactElement, useState } from "react";
import { PLAContext, PLAState } from "./PLAState";

export function PLAManager(props: { children: ReactElement }) {
   const [state, setState] = useState<PLAState>({ projects: [], elements: [], relations: [] });

   return (
      <PLAContext.Provider value={{ state, setState }}>
         {props.children}
      </PLAContext.Provider>
   );
}
